import {
  auditOfficeWorkSummary,
  deleteWorkAssessment,
  exportWorkAssessment,
  getImportWorkAssessmentResult,
  getOfficeWorkAssessmentInfoList,
  getOfficeWorkAssessmentSummaryList,
  getOfficeWorkSummaryList,
  getWorkAssessmentAnalysisData,
  getWorkAssessmentDetail,
  getWorkAssessmentInfoList,
  getWorkAssessmentList,
  importTemplateWorkAssessment,
  importWorkAssessment,
  operateWorkAssessment,
  saveWorkAssessment,
  submitOfficeWorkAssessment,
  submitOfficeWorkSummary,
  submitWorkAssessmentResult,
} from '../services/index';

export default {
  namespace: 'workAssessment',
  state: {},
  effects: {
    // 工作考核列表查询
    *getWorkAssessmentList({ payload }, { call }) {
      const result = yield call(getWorkAssessmentList, payload);
      return result;
    },
    //工作考核列表详情
    *getWorkAssessmentDetail({ payload }, { call }) {
      const result = yield call(getWorkAssessmentDetail, payload);
      return result;
    },
    // 新建/编辑工作考核
    *saveWorkAssessment({ payload }, { call }) {
      const result = yield call(saveWorkAssessment, payload);
      return result;
    },
    // 工作考核 操作方式 开启/结束/驳回
    *operateWorkAssessment({ payload }, { call }) {
      const result = yield call(operateWorkAssessment, payload);
      return result;
    },
    // 工作考核数据统计分布
    *getWorkAssessmentAnalysisData({ payload }, { call }) {
      const result = yield call(getWorkAssessmentAnalysisData, payload);
      return result;
    },
    // 导入考核人员关系
    *importWorkAssessment({ payload }, { call }) {
      const result = yield call(importWorkAssessment, payload);
      return result;
    },
    //导出
    *exportWorkAssessment({ payload }, { call }) {
      const result = yield call(exportWorkAssessment, payload);
      return result;
    },
    //工作考核明细列表
    *getWorkAssessmentInfoList({ payload }, { call }) {
      const result = yield call(getWorkAssessmentInfoList, payload);
      return result;
    },
    //工作考核 删除
    *deleteWorkAssessment({ payload }, { call }) {
      const result = yield call(deleteWorkAssessment, payload);
      return result;
    },
    //工作考核 删除
    *getOfficeWorkAssessmentInfoList({ payload }, { call }) {
      const result = yield call(getOfficeWorkAssessmentInfoList, payload);
      return result;
    },

    //获取导入模板//导出
    *importTemplateWorkAssessment({ payload }, { call }) {
      const result = yield call(importTemplateWorkAssessment, payload);
      return result;
    },
    //递交
    *submitWorkAssessmentResult({ payload }, { call }) {
      const result = yield call(submitWorkAssessmentResult, payload);
      return result;
    },

    // 根据任务序列号查询任务结果
    *getImportWorkAssessmentResult({ payload }, { call }) {
      const result = yield call(getImportWorkAssessmentResult, payload);
      return result;
    },
    //工作总结
    *getOfficeWorkSummaryList({ payload }, { call }) {
      const result = yield call(getOfficeWorkSummaryList, payload);
      return result;
    },
    // 列表查询 考核人视角 考核明细
    //工作总结
    *getOfficeWorkAssessmentSummaryList({ payload }, { call }) {
      const result = yield call(getOfficeWorkAssessmentSummaryList, payload);
      return result;
    },
    // 提交考核

    *submitOfficeWorkSummary({ payload }, { call }) {
      const result = yield call(submitOfficeWorkSummary, payload);
      return result;
    },
    *auditOfficeWorkSummary({ payload }, { call }) {
      const result = yield call(auditOfficeWorkSummary, payload);
      return result;
    },
    *submitOfficeWorkAssessment({ payload }, { call }) {
      const result = yield call(submitOfficeWorkAssessment, payload);
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
